/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";
import { PatternString } from "@pagopa/ts-commons/lib/strings";
import { WithinRangeString } from "@pagopa/ts-commons/lib/strings";

/**
 * Response with payment request information
 */

// required attributes
const PaymentRequestsGetResponseR = t.interface({
  amount: t.union([
    WithinRangeInteger<0, 99999999999, IWithinRangeIntegerTag<0, 99999999999>>(
      0,
      99999999999
    ),
    t.literal(99999999999)
  ])
});

// optional attributes
const PaymentRequestsGetResponseO = t.partial({
  rptId: PatternString("([a-zA-Z0-9]{1,35})|(RFd{2}[a-zA-Z0-9]{1,21})"),

  paFiscalCode: WithinRangeString(11, 12),

  paName: WithinRangeString(1, 141),

  description: WithinRangeString(1, 141),

  dueDate: PatternString(
    "([0-9]{4})-(1[0-2]|0[1-9])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])"
  )
});

export const PaymentRequestsGetResponse = t.intersection(
  [PaymentRequestsGetResponseR, PaymentRequestsGetResponseO],
  "PaymentRequestsGetResponse"
);

export type PaymentRequestsGetResponse = t.TypeOf<
  typeof PaymentRequestsGetResponse
>;
